export default class Meta {
  static setTitle(text) {
    const prepend = text ? `${text} | ` : '';
    document.title = `${prepend}Fabbro in Alessandria | Alfred Daci`;
  }
}
